import {connect, useSelector} from "react-redux";
import React, {useRef, useState} from "react";
import {getCkProductBrandMappingList, updateProductBrandMapping} from "../../../../api/api";
import {
    CButton,
    CCol,
    CForm, CFormInput,
    CInputGroup,
    CInputGroupText,
} from "@coreui/react";
import {Loading} from "../../../../components/common";
import {AgGridReact} from "ag-grid-react";
import * as XLSX from "xlsx";

const ProductBrandMappingExcel = (props) => {
    const { user } = useSelector((props) => props.account);
    const gridRef = useRef();
    const fileRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true,
        enableRangeSelection: true,
        rowSelection: 'multiple',
        enableCellTextSelection: false
    };

    const [columnDefs] = useState([
        { field: "cmpCd", hide: true },
        { field: "productCd", hide: true },
        { field: "상품코드", headerName: "상품코드" },
        { field: "상품명", headerName: "상품명" },
        { field: "바코드", headerName: "바코드" },
        { field: "브랜드코드", headerName: "브랜드연결코드", editable: true, cellEditor: 'agTextCellEditor' },
        { field: "useYn", hide: true }
    ]);

    const save = () => {
        if (confirm("저장하시겠습니까?")) {
            gridRef.current.api.stopEditing();

            setTimeout(() => {
                const updateRows = [];
                gridRef.current.api.forEachNode((node) => {
                    const data = {
                        cmpCd: user.cmpCd,
                        restProductCd: node.data.상품코드 + "",
                        brandProductCd: node.data.브랜드코드.replace("\b", "")
                    }
                    updateRows.push(data);
                })
                console.log(">>> update :: ", updateRows);

                updateProductBrandMapping(updateRows).then((result) => {
                    const {responseBody, responseCode, responseMessage} = result.data;
                    console.log(">>> response :: ", responseBody);
                    if (responseCode === "200") {
                        alert("처리되었습니다.");
                    }
                })
            }, 200)
        }
    }

    const clear = () => {
        if (fileRef.current) {
            fileRef.current.value = '';
        }
        setRowData([]);
    }

    const excelUploadBtnClick = () => {
        fileRef.current.click();
    }

    const readExcelFile = (file, callback) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = function (e) {
            const data = e.target?.result;
            console.log(data);
            const workBook = XLSX.read(data, { type: "binary"});
            callback(workBook);
        }
    }

    const workbookToJson = (workbook) => {
        let jArray = [];
        workbook.SheetNames.forEach(function (sheetName) {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {});
            if (roa.length > 0) jArray.push(roa);
        })
        return jArray[0];
    }

    const upload = (e) => {
        if (e.target.files?.item(0)) {
            const file = e.target.files[0];
            if (!getExtensionOfFilename(file)) {
                alert(".xlsx 확장자만 등록이 가능합니다.");
                clear();
                return;
            }

            clear();
            setLoading(true);
            readExcelFile(file, function (workBook) {
                const json = workbookToJson(workBook);
                setRowData(json);
                setLoading(false);
            })
        }
    }

    const getExtensionOfFilename = (file) => {
        const filename = file.name;
        const _lastDot = filename.lastIndexOf('.');
        const _fileExt = filename.substr(_lastDot, filename.length).toLowerCase();

        return (_fileExt === '.xlsx' || _fileExt === '.xls');
    }

    return (
        <>
            <CForm className="row row-cols-lg-auto p-1 g-1 justify-content-between">
                <div className={"d-grid mt-2"}>
                    <CButton size={"sm"} onClick={excelUploadBtnClick}>엑셀 업로드</CButton>
                    <input type={"file"} accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"} ref={fileRef} style={{display: "none"}} onChange={upload}/>
                </div>
                <div className="d-grid gap-1 d-md-flex justify-content-md-end align-items-center">
                    <CButton size={"sm"} color="dark" onClick={save}>등록</CButton>
                </div>
            </CForm>
            <div className="ag-theme-alpine" style={{ width: "100%", height: 500, marginTop: 10 }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    animateRows={true}
                    singleClickEdit={true}
                    enableRangeSelection={true}
                    enableCellTextSelection={true}
                    suppressClipboardPaste={true}
                    localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}>
                </AgGridReact>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductBrandMappingExcel);